import "@fontsource/noto-sans-jp";
import "./src/styles/base.css";
import "./src/styles/blog-contents-style.css";
// import loaderBg from "./src/images/common/loader-bg.jpg"
import logo from "/src/images/common/logo.png";
export const onRouteUpdate = () => {
  if (typeof document !== "undefined") {
    const elements = document.querySelectorAll(".fadeInUp");
    const jobSections = document.querySelectorAll(".jobSec");
    const pointSections = document.querySelectorAll(".pointSec");
    const recruitSections = document.querySelectorAll(".recruitSec");
    const companySections = document.querySelectorAll(".companySec");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on");
          }
        });
      },
      { threshold: 0.1 },
    );
    elements.forEach((el) => observer.observe(el));
    const checkChicken = () => {
      jobSections.forEach((section) => {
        if (section.classList.contains("is-visible")) return;
        const rect = section.getBoundingClientRect();
        const imageTop = rect.bottom - 68 - 320;
        const imageBottom = rect.bottom - 68;
        if (imageBottom > 0 && imageTop < window.innerHeight) {
          section.classList.add("is-visible");
        }
      });
      pointSections.forEach((section) => {
        if (section.classList.contains("is-visible")) return;
        const rect = section.getBoundingClientRect();
        const imageTop = rect.bottom - 260;
        const imageBottom = rect.bottom + 140;
        if (imageBottom > 0 && imageTop < window.innerHeight) {
          section.classList.add("is-visible");
        }
      });
      recruitSections.forEach((section) => {
        if (section.classList.contains("is-visible")) return;
        const rect = section.getBoundingClientRect();
        const imageTop = rect.bottom - 220;
        const imageBottom = rect.bottom;
        if (imageBottom > 0 && imageTop < window.innerHeight) {
          section.classList.add("is-visible");
        }
      });
      companySections.forEach((section) => {
        if (section.classList.contains("is-visible")) return;
        const rect = section.getBoundingClientRect();
        const imageTop = rect.bottom - 220;
        const imageBottom = rect.bottom;
        if (imageBottom > 0 && imageTop < window.innerHeight) {
          section.classList.add("is-visible");
        }
      });
    };
    window.addEventListener("scroll", checkChicken);
    window.addEventListener("resize", checkChicken);
    checkChicken();
    return () => {
      elements.forEach((el) => observer.unobserve(el));
      window.removeEventListener("scroll", checkChicken);
      window.removeEventListener("resize", checkChicken);
    };
  }
};
export const onClientEntry = () => {
  if (typeof document === "undefined") return;
  document.documentElement.classList.add("js");
  if (window.location.pathname !== "/") return;
  const loader = document.createElement("div");
  loader.className = "loader";
  const bg = document.createElement("div");
  bg.className = "loaderBg";
  bg.style.background = "#fdbc00";
  const overlay = document.createElement("div");
  overlay.className = "loaderOverlay";
  const charactersBox = document.createElement("div");
  charactersBox.className = "loaderCharacters";
  const egg = document.createElement("div");
  egg.className = "loaderCharacter loaderEgg";
  const chick = document.createElement("div");
  chick.className = "loaderCharacter loaderChick";
  const hen = document.createElement("div");
  hen.className = "loaderCharacter loaderHen";
  charactersBox.appendChild(egg);
  charactersBox.appendChild(chick);
  charactersBox.appendChild(hen);
  const inner = document.createElement("div");
  inner.className = "loaderInner";
  const logoImg = document.createElement("img");
  logoImg.src = logo;
  logoImg.className = "logo";
  logoImg.alt = "company logo";
  inner.appendChild(logoImg);
  loader.appendChild(bg);
  loader.appendChild(overlay);
  loader.appendChild(charactersBox);
  loader.appendChild(inner);
  document.body.appendChild(loader);
  setTimeout(() => {
    loader.classList.add("characterShow");
  }, 100);
  setTimeout(() => {
    egg.classList.add("jump");
  }, 300);
  setTimeout(() => {
    chick.classList.add("jump");
  }, 1000);
  setTimeout(() => {
    hen.classList.add("jump");
  }, 1700);
  setTimeout(() => {
    loader.classList.add("logoShow");
  }, 2500);
  setTimeout(() => {
  loader.classList.add("slideUp");
}, 4100);
  setTimeout(() => {
    loader.remove();
    document.body.classList.add("loaded");
  }, 5200);
};
